
import React, { PropTypes} from 'react';

import './style.scss';

const Accordion = props => {

  return (
    <div className="Accordion">
      {props.children}
    </div>
  );
};

Accordion.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element)
};

export default Accordion;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/Accordion/index.js
 **/